import styled  from 'styled-components';
import {
  SimpleTable,
  customScrollbar,
  Content,
  SelectChip,
  CustomScrollbarWrapper,
  IconFileDownload,
  IconSettings
} from 'cdk-radial';
import { Input, TextArea, TextButton } from 'cdk-radial';


import {
  TableContainer
} from 'cdk-radial';

export const StyledIconFileDownload = styled(IconFileDownload)`
  cursor: pointer;
  padding-left:50px;
  padding-right:25px;
  margin-top:10px;
  `

export const StyledIconSettings = styled(IconSettings)`
  cursor: pointer;
  padding-left:50px;
  padding-right:25px;
  margin-top:10px;
  `

export const StyledTableContainer = styled(TableContainer)`
  left: 0px;
`;

export const StyledSelectChip = styled(SelectChip)`
  z-index: 99999;
`;

export const StyledDataCellText = styled(Content)`
  font-weight: ${({fontWeight}) => fontWeight};
  line-height: ${({lineHeight}) => lineHeight};
`;

export const StyledTableWrapper = styled.div`
  width: 100%;

  .ag-root-wrapper {
    border: none !important;
  }

  .ag-pivot-off .ag-header-cell {
    font-size: 17px;
  }

  .ag-cell-wrapper{
    overflow: hidden;
  }

  .ag-menu-option{
    color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  }

  .ag-icon{
    color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  }

  .ag-tabs-header{
      background-color: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : '#f2f2f2')};
  }
  .ag-menu-header{
      background-color: ${({ theme }) => (theme.darkMode ?'#1A1A1A' : '#f2f2f2')};
  }

  .ag-column-select-column-label{
    color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  }
`;


export const StyledContentContainer = styled.div`
  ${customScrollbar};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
`;

export const StyledSideSheetBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 85vh;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const DealerAdminTitle = styled.div`
    display: flex;
    position: relative;
    width:254;
    height:45px;
    border: 0px 0px 1px 0px;
    font-family: Roboto, sans-serif;
    font-size: 1.75rem;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 1.43;
`

export const StyledBaseSimpleTable = styled(SimpleTable)`
  tr:nth-of-type(even) {
    background-color: ${({ theme }) => theme.color.zebraStripe.background.value};
    border-top: 1px solid ${({ theme }) => theme.color.gray[200].value};
  }
  tr:nth-of-type(even):hover {
    background-color: ${({ theme }) => theme.color.zebraStripe.background.value};
  }
  tr:last-child {
    border-bottom: none;
  }
`;

export const StyledIllustrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;


export const StyledInput = styled(Input)`
  margin: 10px 15px 10px 0px;
`;

export const StyledTextArea = styled(TextArea)`
  margin: 10px 15px 10px 0px;
`;

export const StyledTextButton = styled(TextButton)`
  margin: 5px;
`;

export const StyledActionButtonContainer = styled.div<{
  position?: string;
  zIndex?: string;
  positionProps?: Partial<{
    top: string;
    bottom: string;
    left: string;
    right: string;
  }>;
  background?: string;
}>`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0;
  z-index: ${({ zIndex }) => zIndex};
  position: ${({ position }) => position};
  bottom: ${({ positionProps }) => positionProps?.bottom};
  background: ${({ background }) => background};
  // CTA buttons
  :last-child {
    margin-top: auto;
  }
`;

export const  StyledDiv = styled.div<{
  isOpen?:boolean;
}>`
  overflow: auto;
  padding: 10px;
  animation: ${({ isOpen }) => isOpen ? 'inAnimation 300ms ease-in;' : 'outAnimation 300ms ease-out;'};
  animation-fill-mode: forwards;
  @keyframes inAnimation {
    0% {
      max-height: 0px;
    }
    100% {
      max-height: 100%; // max-heght can be adjusted by product team depending on their needs
    }
  }
  @keyframes outAnimation {
    0% {
      max-height: 100%; // max-heght can be adjusted by product team depending on their needs
    }
    100% {
      max-height: 0px;
    }
  }
`;


export const SideSheetDetailContainer = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  border-radius: 16px;
  border: ${({ theme }) => (theme.darkMode ? '2px solid #999999' : 'none')};
  bottom: 16px;
  box-shadow: ${({ theme }) => (theme.darkMode ? 'none' : '0px 8px 25px 2px rgba(0, 0, 0, 0.35)')}; 
  font-family: 'Montserrat', 'Roboto', sans-serif;
  height: auto;
  margin-right: 0px;
  position: fixed;
  top: 56px;
  right:8px;
  z-index: 1002;
  width: ${({ theme }) => (theme.darkMode ? '416px' : '420px')};
  background: ${({ theme }) => (theme.darkMode ? "black" : "white")};
  height: calc(100% - 65px);
  @media (max-width: 470px) {
    width:100vw;
    border-radius: 0px;
    right:0px;
    top: 52px;
  }
`;

export const SideSheetHeader = styled.div`
  border-top-left-radius: 16px 16px;
  border-top-right-radius: 16px 16px;
  align-items: center;
  background: #000;
  color: #fff;
  display: flex;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', 'Roboto', sans-serif;
  min-height: 48px;
  justify-content: space-between;
  line-height: 20px;
  padding: 0 4px;
  position: sticky;
  top: 0;
  z-index: 5;
  @media (max-width: 470px) {
    border-radius: 0px;
  }
`;

export const SideSheetBodyContainer = styled.div`
    font-family: 'Montserrat', 'Roboto', sans-serif;
    display:flex;
    flex-direction:column;
    margin:16px;
    justify-content:space-between;
    height:calc(100vh - 150px);;
`;


export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 50px);
  overflow-x: hidden;
  border-radius:16px;
`;

export const StyledSheet = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  h2 {
    margin-bottom: 4px;
  };
  height:100%;
`;

export const UserCardsHeader = styled.div<{language: string}>`
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    font-size: 20px;
    font-weight: 600;
    padding: 16px 0px;
    @media (max-width: 610px) {
        display:  ${({ language }) =>
            language !== 'en' ? 'grid' : 'flex'};        
      }
      @media (max-width: 467px) {
        width: 97%;        
      }
      @media (max-width: 445px) {
        width: 95%;        
      }
      @media (max-width: 430px) {
        width: 98%;        
      }
      @media (max-width: 405px) {
        width: 95%;        
      }
      @media (max-width: 390px) {
        width: 97%;        
      }
`;

export const StyledWarning = styled.div`
    color: ${({ theme }) => theme.carbon.color.warning};
    padding: 4px;
`;

export const UserCardsContainer = styled.div`
    margin-bottom: 14px;
`

export const StyledUserCardForm = styled.div`
    display: flex;
    padding: 10px;
    height: inherit;
    flex-direction: column;
    > {
        margin 20px 10px;
    }
`;

export const CardButton = styled(TextButton)`
    margin-left: auto;
    font-size: 14px;
    font-weight: 500;
    color: #000;
`;

export const StyledInputContainer = styled.div`
  min-height: auto;
  width: 100%;
  margin-right: 15px;
`;

export const StyledHelperLabelContainer = styled.div`
  display: inline-flex;
  width: 100%;
  margin-top: 0px;
  margin-bottom: 15px;
  padding-left: 6px;
  box-sizing: border-box;
  @media (max-width: 535px) {
      margin-bottom: 20px;
  }
`;

export const StyledHelperLabel = styled.span`
  width: 100%;
  height: 10px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.7);
  flex: none;
  order: 0;
  flex-grow: 0;
  color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
`;  